var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"31":1,"61":1,"64":1,"129":1,"168":1,"178":1,"186":1,"188":1,"192":1,"552":1,"805":1,"985":1,"1289":1,"1362":1,"1496":1,"1525":1,"1564":1,"1605":1,"2006":1,"2026":1,"2058":1,"2155":1,"2165":1,"2364":1,"2540":1,"2554":1,"2679":1,"2775":1,"2791":1,"3046":1,"3101":1,"3167":1,"3250":1,"3296":1,"3313":1,"3363":1,"3547":1,"3705":1,"3718":1,"3735":1,"3742":1,"3925":1,"3995":1,"4386":1,"4475":1,"4512":1,"4623":1,"4727":1,"4889":1,"4968":1,"5094":1,"5168":1,"5176":1,"5289":1,"5314":1,"5459":1,"5620":1,"5664":1,"5788":1,"5981":1,"6331":1,"6413":1,"6471":1,"6635":1,"6749":1,"6805":1,"6846":1,"6916":1,"6949":1,"6969":1,"6979":1,"7116":1,"7141":1,"7223":1,"7505":1,"7506":1,"7524":1,"7584":1,"7963":1,"8168":1,"8172":1,"8207":1,"8209":1,"8234":1,"8252":1,"8460":1,"8462":1,"8469":1,"8615":1,"8671":1,"8722":1,"8839":1,"8925":1,"8947":1,"8980":1,"9310":1,"9386":1,"9430":1,"9454":1,"9507":1,"9598":1,"9635":1,"9771":1,"9957":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr